import { IComponentOptions, IController, IFormController } from 'angular';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { IRawRole } from '../../../../core/services/role/role.interfaces';
import { BusinessRegData } from '../../models/business-reg-data';
import './business-registration-form.component.scss';

export class BusinessRegistrationFormController implements IController {
  static $inject = [
    'AuthService'
  ];
  data = new BusinessRegData();
  form: IFormController;
  isFormVisible = true;
  message: string;
  loading = false;

  constructor( private authService: AuthService ) {
  }

  set parentId( id ) {
    this.data.parent_id = id;
  }

  set userRole( role: IRawRole ) {
    this.reset();
    this.data.role = role.id;
  }

  submit() {
    if ( this.form.$invalid ) {
      return;
    }
    this.isFormVisible = false;
    this.message = 'Your submit was recorded!';
  }

  private reset() {
    this.isFormVisible = true;
  }
}

export const BusinessRegistrationFormComponent: IComponentOptions = {
  controller: BusinessRegistrationFormController,
  template: require('./business-registration-form.component.html'),
  bindings: {
    userRole: '<',
    parentId: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/auth/components/business-registration-form/business-registration-form.component.ts